const Resources = {

    table_headers: [
        // { 
        //   text:     'Inspection Template',
        //   align:    'start',
        //   value:    'inspection_template'
        // },
        {
            text:   'Name',
            value:  'name',
        },

    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'QC',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Inspection Template',
            href:   '/qc-inspection-template',
            arrow:  "<span class='slash'>/</span>",
        },
    ],

    step_table_headers: [
        { 
            name:   'Select',
        },
        {   
            name:   'Inspection Item',
        },
    ],

}

export default Resources;